import {
  getFailed,
  getStarted,
  getSucceeded,
  getEnded,
  statusEnum,
  SIGN_UP_DEFAULT,
  SIGN_UP_INITIALIZATION,
  SIGN_UP_SUBMIT,
  SIGN_UP_SUBMIT_VALIDATION,
  ON_CHANGE_SIGNUP_FORM,
  RESET_FORM,
} from "../actions/constant";
import { Validations } from "../components";
import i18n from "../i18n";

const initialState = {
  isLoading: false,
  status: statusEnum.DEFAULT,
  actionResponse: null,
  ethnicities: null,
  locations: null,
  signUpForm: {},
  disabled: { submit: true },
  stateChanger: true,
  amountReseter: false,
  submit: false,
  submitFailed: false,
};

// Sign up reducer
function reducer(state = initialState, action) {
  const min8 = Validations.min8;
  const max15 = Validations.max15;
  const minOneUppercase = Validations.min_one_uppercase;
  const minOneLowercase = Validations.min_one_lowercase;
  const minOneNumber = Validations.min_one_number;
  const minOneSpecial = Validations.min_one_special;
  const passChecker = (value) => {
    var resutl = undefined;
    var final = "";
    resutl = min8(value);
    if (resutl) return resutl;
    resutl = minOneUppercase(value);
    if (resutl) return resutl;
    resutl = minOneLowercase(value);
    if (resutl) return resutl;
    resutl = minOneNumber(value);
    if (resutl) return resutl;
    resutl = minOneSpecial(value);
    if (resutl) return resutl;
    resutl = max15(value);
    if (resutl) return resutl;
    return "";
  };
  const isValidNumber = (value) => {
    return /^(\d+(\.\d+)?|\.\d+)$/.test(value)  && parseFloat(value) > 0;
  };

  function buttonsChecker() {
    if (
      state.signUpForm.first_name &&
      state.signUpForm.last_name &&
      state.signUpForm.email &&
      !Validations.email(state.signUpForm.email) &&
      state.signUpForm.password &&
      !passChecker(state.signUpForm.password) &&
      state.signUpForm.passwordConfirm &&
      state.signUpForm.passwordConfirm === state.signUpForm.password &&
      state.signUpForm.birthMonth &&
      state.signUpForm.birthMonth !== "null" &&
      state.signUpForm.birthYear &&
      state.signUpForm.birthYear !== "null" &&
      state.signUpForm.gender &&
      state.signUpForm.gender !== "null" &&
      isValidNumber(state.signUpForm.weight) && // Validate weight
      isValidNumber(state.signUpForm.height) && // Validate height
      state.signUpForm.lang &&
      state.signUpForm.lang !== "null" &&
      state.signUpForm.group &&
      state.signUpForm.group !== "null" &&
      // state.signUpForm.ethnicity &&
      state.signUpForm.is_agree &&
      state.signUpForm.is_agree === "false"
    ) {
      state.disabled.submit = false;
    } else {
      state.disabled.submit = true;
    }
  }
  switch (action.type) {
    case RESET_FORM:
      return {
        isLoading: false,
        status: statusEnum.DEFAULT,
        signUpForm: {},
        disabled: { submit: true },
      };

    case SIGN_UP_DEFAULT:
      return {
        ...state,
        isLoading: false,
        status: statusEnum.DEFAULT,
        actionResponse: null,
        ethnicities: null,
        locations: null,
        signUpForm: {},
        disabled: { submit: true },
        stateChanger: !state.stateChanger,
      };
    case getStarted(SIGN_UP_INITIALIZATION): //SIGN_UP_INITIALIZATION_STARTED
    case getStarted(SIGN_UP_SUBMIT):
      return { ...state, isLoading: true, submit: false, submitFailed: false };
    case getSucceeded(SIGN_UP_INITIALIZATION):
      const locations = action.payload[0];
      const ethnicities = action.payload[1];
      const formInitial = action.payload[2];
      const newState = {
        ...state,
        ethnicities: ethnicities,
        locations: locations,
      };
      if (formInitial !== null) {
        newState.formInitial = formInitial;
      }
      return newState;

    case getSucceeded(SIGN_UP_SUBMIT):
      return {
        ...state,
        response: action.payload,
        status: statusEnum.SUCCESS,
        submit: true,
      };

    case getFailed(SIGN_UP_SUBMIT):
      buttonsChecker();
      return {
        ...state,
        actionResponse: {
          message:
            action.payload.params[0] +
            i18n.t("signUp.ALREADY_REGISTERED_EMAIL_TEXT"),
        },

        submit: false,
        submitFailed: true,
      };

    case getEnded(SIGN_UP_INITIALIZATION):
    case getEnded(SIGN_UP_SUBMIT):
      buttonsChecker();
      return {
        ...state,

        isLoading: false,
      };
    case SIGN_UP_SUBMIT_VALIDATION:
      return {
        ...state,
        actionResponse: { message: action.message },
        status: statusEnum.ERROR,
      };
    case ON_CHANGE_SIGNUP_FORM:
      state.signUpForm[action.item.target.name] = action.item.target.value;

      buttonsChecker();
      state.stateChanger = !state.stateChanger;
      return {
        ...state,
        isLoading: false,
      };

    default:
      return state;
  }
}

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/signUpReducer.js